import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Mail } from 'lucide-react';
import { contactInfo } from '../mock';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1e3a5f] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_pro-trucker-learn/artifacts/d07u6gj3_DTS-Logo-White.png" 
                alt="Diamond Trucking School" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="font-bold text-lg">Diamond Trucking School</h3>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Professional CDL training with experienced instructors. Your path to a successful trucking career starts here.
            </p>
          </div>

          {/* Quick Links */}
          <div className="ml-8">
            <h4 className="font-semibold text-lg mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('home')} className="text-gray-300 hover:text-[#d97706] transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('schedule')} className="text-gray-300 hover:text-[#d97706] transition-colors">
                  Schedule
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('programs')} className="text-gray-300 hover:text-[#d97706] transition-colors">
                  Programs
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="text-gray-300 hover:text-[#d97706] transition-colors">
                  FAQ
                </button>
              </li>
            </ul>
          </div>

          {/* Programs */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Our Programs</h4>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li>Class A CDL</li>
              <li>Class B CDL</li>
              <li>Class B to Class A - Upgrade</li>
              <li>Job Placement Assistance</li>
              <li>Flexible Payment Plans</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <a href={`tel:${contactInfo.phone}`} className="text-gray-300 hover:text-[#d97706] transition-colors text-sm">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <a href="mailto:diamondtruckingschool@gmail.com" className="text-gray-300 hover:text-[#d97706] transition-colors text-sm break-all">
                  diamondtruckingschool@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-[#d97706] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">
                  {contactInfo.address}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Diamond Trucking School, Inc. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-[#d97706] text-sm transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-[#d97706] text-sm transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};